import React, { useRef } from 'react';
import { HojaEstilos, HojaEncabezado, Linea, RxFinalTabla, EspecificacionesLentes, exportarHojaPDF } from './HojaVisualFormato';

const VisorConsultaModal = ({ patient, quote, onCancel }) => {
    const printRef = useRef(null);

    if (!quote) return null;

    const patientName = quote.form?.nombre || `${patient?.first_name || ''} ${patient?.last_name || ''}`.trim().toUpperCase() || 'PACIENTE';
    const form = quote.form || {};
    const treatments = quote.treatments || [];
    const rxData = quote.rxData || quote.odontogramaData?.rx || (quote.odontogramaData?.esfera_od !== undefined ? quote.odontogramaData : {}) || {};

    const subtotalCost = treatments.reduce((acc, curr) => acc + ((parseFloat(curr.precio) || 0) * (parseInt(curr.cantidad) || 1)), 0);
    const discountPct = parseFloat(form.discountPercentage) || 0;
    const globalDiscountAmount = (subtotalCost * discountPct) / 100;
    const finalTotalCost = subtotalCost - globalDiscountAmount;

    const handlePrint = async () => {
        try {
            await exportarHojaPDF(document.getElementById('print-quote-modal-area'), `Presupuesto_Optico_${patientName}.pdf`);
        } catch (error) {
            console.error("Error generando PDF", error);
        }
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 10000, overflowY: 'auto' }}>
            {/* Barra superior de control */}
            <div className="d-print-none sticky-top" style={{ backgroundColor: '#1e293b', padding: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
                <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    <i className="bi bi-eyeglasses me-2 text-info"></i>
                    Presupuesto & Receta Óptica: {patientName} ({quote.date})
                </span>
                <button onClick={handlePrint} className="btn btn-light fw-bold px-4 rounded-pill">
                    <i className="bi bi-printer-fill me-2"></i> Imprimir / PDF
                </button>
                <button onClick={onCancel} className="btn btn-danger fw-bold px-4 rounded-pill">
                    <i className="bi bi-x-circle-fill me-2"></i> Cerrar
                </button>
            </div>

            <style>
                {`
                    @media print {
                        body * { visibility: hidden; }
                        #print-quote-modal-area, #print-quote-modal-area * { visibility: visible !important; }
                        #print-quote-modal-area { position: absolute !important; left: 0 !important; top: 0 !important; width: 100% !important; margin: 0 !important; padding: 0 !important; box-shadow: none !important; }
                    }
                    .pill-table-modal { width: 100%; border-collapse: separate; border-spacing: 0 4px; font-size: 11px; text-align: center; }
                    .pill-table-modal th { padding: 3px; font-weight: 900; }
                    .pill-table-modal td { background-color: #f3f4f6; padding: 4px; height: 24px; border-left: 2px solid white; border-right: 2px solid white; }
                    .pill-table-modal td:first-child { border-top-left-radius: 20px; border-bottom-left-radius: 20px; border-left: none; }
                    .pill-table-modal td:last-child { border-top-right-radius: 20px; border-bottom-right-radius: 20px; border-right: none; }
                `}
            </style>

            <div id="print-quote-modal-area" ref={printRef} style={{ width: '210mm', minHeight: '270mm', backgroundColor: 'white', margin: '20px auto', padding: '10mm', boxSizing: 'border-box', position: 'relative', fontFamily: "'Segoe UI', Roboto, sans-serif", boxShadow: '0 4px 15px rgba(0,0,0,0.2)', display: 'flex', flexDirection: 'column', borderRadius: '8px' }}>
                
                <HojaEstilos />
                <HojaEncabezado titulo="PRESUPUESTO & RECETA ÓPTICA" style={{ paddingLeft: 0 }} />

                {/* Datos del paciente (formato de la hoja impresa) */}
                <div className="hv-frame" style={{ marginBottom: '12px' }}>
                    <div className="hv-row2">
                        <Linea label="NOMBRES Y APELLIDOS:" value={patientName} readOnly inputStyle={{ fontWeight: 700 }} />
                        <Linea label="C.I.:" value={form.cedula || patient?.cedula} readOnly />
                    </div>
                    <div className="hv-row2">
                        <Linea label="REPRESENTANTE:" value={form.representante || patient?.representative} readOnly />
                        <Linea label="C.I. REP.:" value={form.cedulaRepresentante || patient?.representative_cedula} readOnly />
                    </div>
                    <div className="hv-row2">
                        <Linea label="DIRECCIÓN:" value={form.direccion || patient?.address} readOnly />
                        <Linea label="FECHA NAC.:" value={form.fechaNacimiento || patient?.birth_date} readOnly />
                    </div>
                    <div className="hv-row2">
                        <Linea label="TELÉFONO:" value={form.telefono || patient?.phone} readOnly />
                        <Linea label="OCUPACIÓN:" value={form.ocupacion || patient?.occupation} readOnly />
                    </div>
                    <Linea label="CORREO:" value={form.correo || patient?.email} readOnly style={{ width: '62%', marginBottom: 0 }} />
                </div>

                {/* RX. FINAL + especificaciones de lentes */}
                <div className="hv-frame" style={{ marginBottom: '14px' }}>
                    <RxFinalTabla data={rxData} readOnly />
                    <EspecificacionesLentes data={rxData} readOnly />
                </div>

                {/* Tabla de productos y servicios */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <h3 style={{ margin: 0, fontSize: '13px', fontWeight: '900', letterSpacing: '0.5px' }}>DETALLE DE PRODUCTOS & SERVICIOS ÓPTICOS</h3>
                </div>
                <table className="pill-table-modal">
                    <thead>
                        <tr>
                            <th style={{ width: '8%' }}>N°</th>
                            <th style={{ width: '47%' }}>PRODUCTO / SERVICIO</th>
                            <th style={{ width: '15%' }}>CANTIDAD</th>
                            <th style={{ width: '15%' }}>PRECIO UNIT.</th>
                            <th style={{ width: '15%' }}>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {treatments.map((t, i) => (
                            <tr key={i}>
                                <td style={{ fontWeight: 'bold' }}>{i + 1}</td>
                                <td style={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '15px' }}>{t.procedimiento || '-'}</td>
                                <td>{t.cantidad || 1}</td>
                                <td>${parseFloat(t.precio || 0).toFixed(2)}</td>
                                <td style={{ fontWeight: 'bold' }}>
                                    ${(t.total_final !== undefined ? parseFloat(t.total_final) : ((parseFloat(t.precio) || 0) * (parseInt(t.cantidad) || 1))).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                        {[...Array(Math.max(0, 3 - treatments.length))].map((_, i) => (
                            <tr key={`empty-${i}`}>
                                <td></td><td></td><td></td><td></td><td></td>
                            </tr>
                        ))}
                        <tr style={{ backgroundColor: 'transparent' }}>
                            <td colSpan="3" style={{ backgroundColor: 'transparent', paddingRight: '15px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: '900', fontSize: '14px' }}>
                                    <span>SUBTOTAL</span>
                                </div>
                            </td>
                            <td colSpan="2" style={{ fontWeight: '900', fontSize: '14px', backgroundColor: 'transparent', textAlign: 'center' }}>
                                ${subtotalCost.toFixed(2)}
                            </td>
                        </tr>
                        
                        <tr style={{ backgroundColor: 'transparent' }}>
                            <td colSpan="3" style={{ backgroundColor: 'transparent', paddingRight: '15px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: '900', fontSize: '14px' }}>
                                    <span>DESCUENTO {discountPct > 0 ? `(${discountPct}%)` : ''}</span>
                                </div>
                            </td>
                            <td colSpan="2" style={{ fontWeight: '900', fontSize: '14px', backgroundColor: 'transparent', textAlign: 'center' }}>
                                ${globalDiscountAmount.toFixed(2)}
                            </td>
                        </tr>
                        
                        <tr style={{ backgroundColor: 'transparent' }}>
                            <td colSpan="3" style={{ backgroundColor: 'transparent', paddingRight: '15px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: '900', fontSize: '14px' }}>
                                    <span>TOTAL A PAGAR</span>
                                </div>
                            </td>
                            <td colSpan="2" style={{ fontWeight: '900', fontSize: '14px', backgroundColor: 'transparent', textAlign: 'center' }}>
                                ${finalTotalCost.toFixed(2)}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Footer */}
                <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', backgroundColor: '#e5e7eb', borderRadius: '30px', padding: '8px 20px', alignItems: 'center' }}>
                    <div style={{ fontSize: '10px', fontWeight: 'bold', display: 'flex', gap: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#374151' }}>
                            <i className="bi bi-whatsapp"></i> CONTÁCTANOS: 0962602999
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#374151' }}>
                            <i className="bi bi-geo-alt-fill"></i> DIRECCIÓN: ENTRE ARELLANO Y AYACUCHO
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default VisorConsultaModal;
